import { CreationResponse } from '../../api/client';

// Use the Owner type from CreationResponse directly
type Owner = CreationResponse['owner'];

interface OwnerInfoProps {
  owner: Owner;
  isShared: boolean | undefined;
}

export function OwnerInfo({ owner, isShared }: OwnerInfoProps) {
  // Only show if there's an owner and it's a shared creation
  if (!owner || !isShared) {
    return null;
  }
  
  // Build the owner's full name
  const getOwnerName = () => {
    if (owner?.username) {
      return `@${owner.username}`;
    }
    
    const firstName = owner?.first_name || '';
    const lastName = owner?.last_name || '';
    
    if (firstName || lastName) {
      return `${firstName} ${lastName}`.trim();
    }
    
    return 'Unknown User';
  };
  
  return (
    // Adjusted styling for inline display
    <div className="flex items-center gap-1.5 text-sm text-muted mt-1">
      <span className="material-symbols-outlined text-base">person</span>
      <span className="font-medium text-muted-strong">{getOwnerName()}</span>
    </div>
  );
} 